package one.healthium.domain.common

enum class BMIRange(
    val range: IntRange,
) {
    Underweight(0..18),
    Normal(19..25),
    Overweight(26..31),
    Obese(32..Int.MAX_VALUE);

    companion object {
        fun byValue(value: Int): BMIRange {
            return entries.first { it.range.contains(value) }
        }
    }
}